import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const sessionRoutes = /^\/(admin|superadmin|student360|puanlarim|avatarim|odemelerim)(?:\/|$)|^\/mini-tasks\/parent(?:\/|$)/;

export default function SessionSiteGuard({ children }) {
  const location = useLocation();
  const hostname = window.location.hostname;
  const requiresRedirect = (hostname === 'dandu.com.tr' || hostname === 'www.dandu.com.tr')
    && sessionRoutes.test(location.pathname);
  let target = '';
  if (requiresRedirect) {
    // Cookie sessions use the same site as api.kolaykarekod.com.
    const url = new URL('https://kolaykarekod.com');
    url.pathname = location.pathname;
    url.search = location.search;
    url.hash = location.hash;
    target = url.toString();
  }

  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);

  // Redirect before mounting guards or login views that would call the API.
  return target ? null : children;
}
